/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_SwapInputs */

const en_us2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap exercise`)
};

const pt_br2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const es_419_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar ejercicio`)
};

const pt_pt2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const fr_fr2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d'exercice`)
};

const de_de2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung tauschen`)
};

const it_it2_plan_edit_swap = /** @type {(inputs: Plan_Edit_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia esercizio`)
};

/**
* | output |
* | --- |
* | "Swap exercise" |
*
* @param {Plan_Edit_SwapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_swap = /** @type {((inputs?: Plan_Edit_SwapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_SwapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_swap(inputs)
	if (locale === "es-419") return es_419_plan_edit_swap(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_swap(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_swap(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_swap(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_swap(inputs)
	return en_us2_plan_edit_swap(inputs)
});
export { plan_edit_swap as "plan-edit.swap" }